import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Stack,
    Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

export interface ConflictOrder {
    id: string;
    order_name: string;
    po_number?: string | null;
    created_at?: string;
}

export interface OrderConflict {
    code: "DUPLICATE_PO" | "SIMILAR_ORDER_WARNING";
    message: string;
    existing_order?: ConflictOrder;
    matching_orders?: ConflictOrder[];
}

interface OrderConflictModalProps {
    conflict: OrderConflict | null;
    isLoading: boolean;
    onClose: () => void;
    onConfirmSimilar: () => void;
}

const OrderRow = ({ order }: { order: ConflictOrder }) => (
    <Stack spacing={0.5} sx={{ py: 1.5 }}>
        <Link
            to={`/product-orders/${order.id}`}
            target="_blank"
            rel="noreferrer"
            style={{ fontWeight: 700, color: "#0058a0" }}
        >
            {order.order_name}
        </Link>
        <Typography variant="body2" color="text.secondary">
            Mã PO: {order.po_number || "—"}
            {order.created_at
                ? ` · Tạo lúc ${dayjs(order.created_at).format("HH:mm DD/MM/YYYY")}`
                : ""}
        </Typography>
    </Stack>
);

const OrderConflictModal = ({
    conflict,
    isLoading,
    onClose,
    onConfirmSimilar,
}: OrderConflictModalProps) => {
    const isSimilar = conflict?.code === "SIMILAR_ORDER_WARNING";
    const orders = isSimilar
        ? conflict?.matching_orders || []
        : conflict?.existing_order
          ? [conflict.existing_order]
          : [];

    return (
        <Dialog open={Boolean(conflict)} onClose={isLoading ? undefined : onClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ fontFamily: "Noto Sans", fontWeight: 700 }}>
                {isSimilar ? "Phát hiện đơn hàng trùng" : "Không thể tạo đơn hàng"}
            </DialogTitle>
            <DialogContent>
                <Typography sx={{ fontFamily: "Noto Sans", mb: orders.length ? 1 : 0 }}>
                    {conflict?.message}
                </Typography>
                {orders.map((order, index) => (
                    <div key={order.id}>
                        {index > 0 && <Divider />}
                        <OrderRow order={order} />
                    </div>
                ))}
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3 }}>
                <Button onClick={onClose} disabled={isLoading}>
                    Tiếp tục chỉnh sửa
                </Button>
                {isSimilar && (
                    <Button
                        variant="contained"
                        onClick={onConfirmSimilar}
                        disabled={isLoading}
                    >
                        Vẫn tạo đơn
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default OrderConflictModal;
